import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Alert } from 'react-bootstrap';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await login(username, password);
            navigate('/calculate');
        } catch (err) {
            setError('Falha no login. Verifique suas credenciais.');
        }
    };

    return (
        <div className="bc-auth">
            {/* Painel esquerdo — branding */}
            <div className="bc-auth-left">
                <div className="bc-auth-left-content">
                    <img src={"benfecalc.svg"} alt="BenfeCalc" height="56" />
                    <div className="bc-auth-tagline">
                        Avaliação de<br />Benfeitorias<br />Imobiliárias
                    </div>
                    <div className="bc-auth-sub">
                        Cálculo preciso de depreciação pelo método Ross-Heidecke com suporte a lotes e loteamentos.
                    </div>
                    <div className="bc-auth-feats">
                        <div className="bc-auth-feat">
                            <span className="fi">📐</span>
                            Método Ross-Heidecke
                        </div>
                        <div className="bc-auth-feat">
                            <span className="fi">🗺️</span>
                            Avaliação de Lotes com Google Maps
                        </div>
                        <div className="bc-auth-feat">
                            <span className="fi">📄</span>
                            Relatórios em PDF
                        </div>
                        <div className="bc-auth-feat">
                            <span className="fi">📊</span>
                            Histórico completo
                        </div>
                    </div>
                </div>
            </div>

            {/* Painel direito — formulário */}
            <div className="bc-auth-right">
                <div className="bc-auth-box">
                    <div className="bc-auth-title">Bem-vindo de volta</div>
                    <div className="bc-auth-subtitle">Entre com suas credenciais para continuar</div>

                    {error && (
                        <Alert className="bc-alert" variant="danger" dismissible onClose={() => setError('')}>
                            {error}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="bc-label">Usuário ou E-mail</label>
                            <input
                                type="text"
                                className="form-control bc-input"
                                placeholder="Digite seu usuário ou e-mail"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                autoFocus
                            />
                        </div>
                        <div className="mb-4">
                            <label className="bc-label">Senha</label>
                            <input
                                type="password"
                                className="form-control bc-input"
                                placeholder="Digite sua senha"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="btn bc-btn bc-btn-primary w-100 mb-3">
                            Entrar
                        </button>
                    </form>

                    <div className="text-center" style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>
                        Acesso restrito. Entre em contato com o administrador para obter acesso.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
